<template lang="html">
    <article class="media">
      <div class="media-content">
        <div class="content">
          <p>
            <strong>Senior Infrastructure Engineer</strong> | AppFolio - <small>May 2021 - May 2023</small>
            <br>
            My role at AppFolio involved advising on and implementing incremental improvements to global infrastructure needs.
            I bin packed my time working within development teams, regularly contributing to backend services and APIs.
            Throughout my tenure, I created frontend user interfaces and implemented Infrastructure as Code solutions
            while collaborating across multiple development teams.
            </p>
        </div>
      </div>
    </article>
  </template>
  
  <script>
  export default {
    name: "appfolio"
  }
  </script>
  
  <style lang="css">
  </style>
  


// WEBPACK FOOTER //
// src/components/jobs/AppFolio.vue